<template>
  <div class="no-data">
    <CmImg
      name="noData"
      :style="{
        width,
        height
      }"
    />
    <div
      class="no-data-name"
      :style="{
        color: color
      }"
    >
      {{ t('no_data') }}
    </div>
  </div>
</template>
<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const height = ref('')
const width = ref('')
const color = ref('#000')
if (window.__themeEnv === 'TKBIT') {
  height.value = '200px'
  width.value = '284px'
  color.value = '#000'
} else if (window.__themeEnv === 'ARKADEX') {
  height.value = '100px'
  width.value = '100px'
  color.value = '#fff'
} else if (window.__themeEnv === 'CICC') {
  height.value = '100px'
  width.value = '100px'
  color.value = '#000'
} else if (window.__themeEnv === 'CMBIT') {
  height.value = '100px'
  width.value = '100px'
  color.value = '#fff'
} else if (window.__themeEnv === 'YT') {
  height.value = '100px'
  width.value = '100px'
  color.value = '#000'
} else if (window.__themeEnv === 'EXMINING') {
  height.value = '57px'
  width.value = '63px'
  color.value = 'rgb(147, 147, 147)'
}
</script>
<style lang="scss" scoped>
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .no-data-name {
    margin-top: 20px;
    font-size: 14px;
    color: #000;
  }
}
</style>
